import DualloMarkerGroundTruthClient from "@/clients/duallo/DualloMarkerGroundTruthClient";

/**
 * Human-added false-negative boxes (anomalies the model missed) for a scan.
 * Bboxes are in image pixels, centre x/y plus width/height — matching provenance
 * and Roboflow — so review + export share one coordinate convention.
 */
class MarkerGroundTruthService {
    async getByScanId(scanId) {
        return await DualloMarkerGroundTruthClient.getByScanId(scanId);
    }

    async create(request) {
        return await DualloMarkerGroundTruthClient.create(request);
    }

    async delete(scanId, id) {
        return await DualloMarkerGroundTruthClient.deleteById(scanId, id);
    }
}

export default new MarkerGroundTruthService();
